import React, { Component, useState, useMemo, useEffect } from 'react';

import { fetchData } from "../common/networkRequests";

import './ModalStyle.css';
import { FaArrowDown, FaRegWindowRestore } from "react-icons/fa";

import { getObjectsValue, clearDisplayData, forceClearData, calculateInterest, padding, RelevantIcon, goToName } from '../oro-module/commonFunctions';


const freezeDef = { 1: "Unfreeze", 2: "Full Freeze", 3: "Partial Freeze", 4: "Credit Freeze", 5: "Debit Freeze" }

const createAcNo = ({ typed, pageData }) => {
  // let definition = [{ len: 4, source: 'branch_code', pad: '0', padDir: 'left' }, { len: 5, source: 'product_code' }, { len: 6, source: 'typed' }];
  // For Parbhani
  let definition = [{ len: 4, source: 'branch_code', pad: '0', padDir: 'left' }, { len: 4, source: 'product_code' }, { len: 7, source: 'typed' }];
  // Osmanabad
  // let definition = [{ len: 4, source: 'branch_code', pad: '0', padDir: 'left' }, { len: 2, source: 'schema_code' },{ len: 2, source: 'product_code' }, { len: 7, source: 'typed' }];

  let blocks = String(typed).split(".");
  // If only acno is typed, then create full acno. If 21933 typed, then make 0002+11128+021933
  // If acno & product is typed, then prepend branch. If 21933 typed, then make 0002+11128+021933
  let final;
  let totalLength = 0;
  definition.map(def => totalLength += def.len)
  //
  if (blocks.length == 1) {
    // 21933 => 000211128021933
    if (String(typed).length == totalLength || (pageData[definition[0]['source']] && pageData[definition[1]['source']])) {
      if (blocks[0].length <= definition[2]['len']) {
        final = padding({ typed: pageData[definition[0]['source']], len: definition[0]['len'] }) + padding({ typed: pageData[definition[1]['source']], len: definition[1]['len'] }) + padding({ typed: blocks[0], len: definition[2]['len'] })
      } else {
        final = String(typed);
      }
    } else {
      final = '';
    }
  } else if (blocks.length == 2) {
    if (pageData[definition[0]['source']]) {
      final = padding({ typed: pageData[definition[0]['source']], len: definition[0]['len'] }) + padding({ typed: blocks[0], len: definition[1]['len'] }) + padding({ typed: blocks[1], len: definition[2]['len'] })
    } else {
      final = '';
    }
  }
  else if (blocks.length == 3) {
    final = padding({ typed: blocks[0], len: definition[0]['len'] }) + padding({ typed: blocks[1], len: definition[1]['len'] }) + padding({ typed: blocks[2], len: definition[2]['len'] })
  }
  return final;
}

function handlePrompt(type) {
  let typed = prompt(`${type.toUpperCase()} doesn't exist!\nDo you want to update now?`);
  return typed;
}

const getDefaultValue = (props) => {
  let boxval;

  let { defaultValue, name } = props.component;
  let { LocalVars, pageData } = props.parentState;
  let { selectedTourBranch } = LocalVars;


  if (defaultValue == 'assigned_branch') {
    if (selectedTourBranch) {
      boxval = selectedTourBranch.code;
    } else {
      let { profile } = props.parentProps.parentState;
      boxval = profile.assigned_branch;

      // alert("Branch is not assigned");
    }
  }
  else if (defaultValue == 'assigned_bank') {
    let { profile } = props.parentProps.parentState;
    boxval = profile.assigned_bank;
  }
  else {
    boxval = defaultValue;
  }
  return boxval;
}


const CommonControlCustom = (props) => {

  let [boxClass, setBoxClass] = useState(false);
  let [lastTyped, setlastTyped] = useState(0);
  let [suggestions, setSuggestions] = useState([]);
  let [suggestionIdx, setSuggestionIdx] = useState(false);
  let [suggestionsDisplay, setSuggestionsDisplay] = useState(false);
  let [focused, setFocused] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const tooltipID2 = "TTID" + props.component.tab + props.parentState.currentPage + props.component.name;

  const setErrorMessages = (props, errorMessage) => {
    let x = props.parentState.errorMessages;
    let { modalname } = props.parentState;
    let varname = props.component.name;
    if (modalname) {
      if (x[modalname]) {
        errorMessage ? x[modalname][varname] = errorMessage : delete x[modalname][varname]
      } else {
        errorMessage ? x[modalname] = { [varname]: errorMessage } : delete x[varname]
      }
    } else {
      errorMessage ? x[varname] = errorMessage : delete x[varname]
    }
    props.liftGlobalState({ name: "errorMessages" }, x);
  }




  const handleChange = (e, props) => {
    let errorMessage = "";
    if (props.component.validations) {
      props.component.validations.map(validation => {
        let result = validation.rule.exec(e.target.value);
        if (!result) {
          if (
            (!props.component.isRequired == true &&
              String(e.target.value).length != 0) ||
            props.component.isRequired
          ) {
            errorMessage = validation.message;
          } else {
            errorMessage = "";
          }
        } else {
          errorMessage = "";
        }
      });
    }



    setErrorMessages(props, errorMessage);
    let v = e.target.value;
    // setCurrentValue(v);
    props.liftState(props.component, v);

    clearOtherData();

    if (props.component.length && String(v).length > props.component.length) {
      setlastTyped(new Date().getTime());
    }

  }

  const getLatestData = async (reverse = false, isReadOnly1 = false) => {
    // Check specific tasks mentioned in onleave
    let { isReadOnly, onLeave, beforeLeave, name, autoopen, displayData } = props.component;
    let { formState, pageData, remoteip, LocalVars, controlsData } = props.parentState;
    LocalVars['lastTypedComp'] = name;
    props.liftGlobalState({ name: 'LocalVars' }, LocalVars);
    let current = { props };
    let baseid = name.replace("_code", "_id");
    let typedValue = !reverse ? pageData[name] : pageData[baseid];
    let CBSurl = `${remoteip}/sentry`;
    let url = CBSurl;
    if (beforeLeave && beforeLeave.length > 0 && typedValue && String(typedValue).trim() != "") {
      if (beforeLeave && beforeLeave.indexOf('createAcNo') != -1) {
        typedValue = createAcNo({ typed: typedValue, pageData });
      };
      props.liftState(props.component, typedValue);
    }

    if ((!isNaN(typedValue) && typedValue) || (typedValue && isNaN(typedValue) && String(typedValue).trim() != "") || ((!typedValue || String(typedValue).trim() != '') && autoopen && focused)) {

      getControlsData({ props, value: typedValue, readonly: isReadOnly1, reverse, fieldName: name });

      // if (reterr && Object.keys(reterr).length == 0) {

      // }
    } else {
      // if blank, clear displaydata.
      let datas = clearDisplayData({ displayData, name });
      props.liftState(datas.keys, datas.values);

    }
  }

  const clearOtherData = () => {
    let { displayData, isReadOnly, name, clearData, autoopen } = props.component;
    setFocused(true);
    let datas = { keys: [], values: [] };
    let { formState, showFilter, pageData } = props.parentState;

    if (autoopen && !pageData[name]) {
      setlastTyped(new Date().getTime());
    } else {
      let { formElements, currentPage } = props.parentState;
      datas = clearDisplayData({ datas, displayData, name });
      if (clearData) {
        datas = forceClearData({ datas, clearData, formElements, currentPage, showFilter });
      }
      props.liftState(datas.keys, datas.values);
    }
  }


  const handleBlur = (e) => {
    let { displayData, isReadOnly, name, clearData, autoopen } = props.component;
    let { pageData } = props.parentState;
    if (!isReadOnly || (!pageData.unique_id && isReadOnly == 'edit')) {
      setFocused(false);
      setlastTyped(new Date().getTime());
    }
  }

  const generateOtherValues = (sendData) => {
    let { pageData, openmodals } = props.parentState;
    let returnVal = {}
    if (sendData.length != 0) {
      sendData.map(otherfield => {
        if (otherfield.varname) {
          if (otherfield.fixed) {
            returnVal[otherfield.varname] = otherfield.fixed;
          }
          else if (otherfield.source) {
            if (otherfield.source == 'profile') {
              let { profile } = props.parentProps.parentState;
              returnVal[otherfield.varname] = getObjectsValue(profile, otherfield.value);
            }
          }
          else {
            returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
          }
        } else {
          returnVal[otherfield] = getObjectsValue(pageData, otherfield);
        }
      })
    }
    return returnVal
  }




  const getControlsData = async ({ props, value = "", readonly, reverse, fieldName }) => {

    setLoading(true);
    let {
      currentPage, pageData, controlsData, tempAutoopenValues
    } = props.parentState;
    let { autoopen } = props.component;
    let retval = []; let reterr = [];
    let lgs = props.liftGlobalState;

    if ((value && String(value).trim() != '') || ((!value || String(value).trim() != '') && autoopen)) {
      let { token } = props.parentProps.parentState;
      let { dataType, sendData } = props.component.sendToServer;
      let { placeHolder, name } = props.component;
      let method = 'post';

      if (fieldName.indexOf('[') != -1) {
        let fn = fieldName.split('[');
        fieldName = fn[fn.length - 1].replace("]", "");
      }


      const afterControl = (response) => {
        setLoading(false);

        let lgs = props.liftGlobalState;
        let retval = []; let reterr = [];


        // let suggestions;
        let { results, exceptions, vendorErrors, error, success } = response;

        if (error || !results) {
          setErrorMessages(props, error);
          setSuggestions([]);
        }
        else if (results.length == 1) {
          results = results[0];
          retval = results;
          let x;
          (results && results.error) ? exceptions = results.error : x = 0;
          reterr = exceptions;

          if (success) {
            let warnings = [];
            let errors = [];
            let checkboxes = [];

            // Check sys_warning_ and show alert.
            for (var key in results) {
              if (key.indexOf('sys_error_') == 0 && results[key]) {
                errors.push(results[key]);
                break;
              }
              else if (key.indexOf('sys_warning_') == 0 && results[key]) {
                warnings.push(results[key]);
              }
              else if (key.indexOf('sys_checkbox_') == 0 && results[key] == 1) {
                checkboxes.push(results[key]);
                props.liftState({ name: key }, 1);
              }
            }

            if (errors.length > 0) {
              // clear typed value.
              alert(errors[0]);
              props.liftState(props.component, "");
            } else {
              for (var i = 0; i < warnings.length; i++) {
                alert(warnings[i]);
              }
              setErrorMessages(props, "");

              let { displayData, name } = props.component;

              let dispname = name.replace("_code", "_display");
              let dispuid = name.replace("_code", "_uid");
              for (var key in displayData) {
                let skip = false;
                let fieldName = displayData[key];
                if (displayData[key].field) {
                  fieldName = displayData[key].field;
                  if (displayData[key].skip) {
                    skip = true;
                  }
                }
                lgs({ name: "alerts" }, []);
                if (!skip || (!pageData[fieldName] || pageData[fieldName] != results[key])) {
                  props.liftState({ "name": fieldName }, results[key]);
                }
              }
              if (reverse) {
                let resin = name.split(".");
                let valfield = resin[resin.length - 1];
                props.liftState({ "name": name }, results[valfield]);
              }
            }
          }
          setSuggestions([]);
        } else {
          setSuggestions(results);
          setSuggestionIdx(1);
          if (!value || value == '') {
            props.liftGlobalState({ name: 'tempAutoopenValues' }, { [dataType]: results })
          }
        }

        if (!reterr || Object.keys(reterr).length == 0) {
          controlsData[fieldName] = retval;
          lgs({ name: "controlsData" }, controlsData);
        }
      }

      let saveThis = { dataType, value, reverse, dependantOnValues: sendData && generateOtherValues(sendData), currentPage, fieldName, readonly };

      // start animation
      let starttime = new Date().getTime();
      let response;
      // if (tempAutoopenValues && tempAutoopenValues[dataType]) {
      //   response = { results: tempAutoopenValues[dataType] };
      //   console.log({ response2: response })
      // } else {
      //   response = await fetchData({ url: 'cbsurl', postData: saveThis, method, current: { props } });
      // }
      // console.log({ reverse, fieldName, saveThis })

      fetchData({ url: 'cbsurl', postData: saveThis, method, current: { props }, cbf: afterControl });


    } else {
      setErrorMessages(props, "");
      // props.liftGlobalState({ name: "errorMessages" }, {});
      lgs({ name: "alerts" }, []);
    }



    return { retval, reterr };
  }

  const handleFocus = async (e) => {
    let { displayData, isReadOnly, name, clearData, autoopen } = props.component;

    if (!isReadOnly) {
      setFocused(true);
      let datas = { keys: [], values: [] };
      let { formState, showFilter, pageData } = props.parentState;

      if (autoopen && !pageData[name]) {
        setlastTyped(new Date().getTime());
      }
    }

    // else {
    //   if (formState != 'edit' || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit')) {
    //   } else {
    //     let { formElements, currentPage } = props.parentState;
    //     datas = clearDisplayData({ datas, displayData, name });
    //     if (clearData) {
    //       datas = forceClearData({ datas, clearData, formElements, currentPage, showFilter });
    //       // console.log({ datas })
    //     }
    //     props.liftState(datas.keys, datas.values);
    //   }
    // }
  }

  const handleShowSuggestions = () => {
    // setlastTyped(new Date().getTime());
    let { name } = props.component;

    if (suggestions.length > 0) {
      setSuggestionsDisplay(false);
      setSuggestions([]);
    } else {
      props.liftState({ name }, "");
      let r = document.getElementsByName(name);
      if (r) {
        r[0].focus();
      }
    }
  }

  const handleSuggestionSelect = (val) => {
    props.liftState(props.component, val);
    setSuggestions([]);
    setSuggestionsDisplay(false);
    setlastTyped(new Date().getTime());
  }

  const Suggestions = ({ data }) => {
    let width = props.parentState.screen.width;
    let { showSidebar, formElements } = props.parentState;
    let { fastpath } = props.component;

    let persm;
    showSidebar ? persm = width / 17 : persm = width / 15;
    let c_code = compTracker + "_code";
    let c_display = compTracker + "_display";

    if (compTracker.indexOf(']') != -1) {
      var regExp = /\[.*?\]/g;
      let matched = compTracker.match(regExp)
      c_code = matched[matched.length - 1].replace('[', '').replace(']', '') + "_code"
      c_display = c_code.replace('_code', '_display]');
    }
    return (
      <div className="row suggestion-modal" style={{ width: persm * 2, marginLeft: 0 }}>
        <div className={`col-sm-12`} style={{ padding: 0 }}>
          {data.map((sug, idx) => {
            let isActive = suggestionIdx - 1 == idx ? true : false;
            return (
              <div style={{ backgroundColor: isActive ? "#eff8ff" : "white", borderRadius: 4 }} onClick={() => handleSuggestionSelect(sug[c_code])} className="row suggestion-row" key={idx}>
                <div style={{ fontWeight: isActive ? "bold" : "" }} className="col-sm-12">{sug[c_code]}-{sug[c_display]}</div>
                {/* <div style={{ fontWeight: isActive ? "bold" : "" }} className="col-sm-8">{sug[c_display]}</div> */}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const showSuggestions = (e) => {
    let c_code = compTracker + "_code";
    let c_display = compTracker + "_display";

    if (compTracker.indexOf(']') != -1) {
      var regExp = /\[.*?\]/g;
      let matched = compTracker.match(regExp)
      c_code = matched[matched.length - 1].replace('[', '').replace(']', '') + "_code"
      c_display = c_code.replace('_code', '_display]');
    }
    if (e.which == 40) {
      if (suggestions.length > 0) {
        if (suggestionIdx) {
          if (suggestionIdx < suggestions.length) {
            setSuggestionIdx(suggestionIdx + 1);
          }
          else {
            setSuggestionIdx(1);
          }
        } else {
          setSuggestionIdx(1);
        }
      }
    }
    else if (e.which == 38) {
      if (suggestions.length > 0 && !suggestionIdx) {
        setSuggestionIdx(suggestions.length);
      }
      else if (suggestions.length > 0 && suggestionIdx) {
        if (suggestionIdx > 1) {
          setSuggestionIdx(suggestionIdx - 1);
        }
        else {
          setSuggestionIdx(suggestions.length);
        }
      } else {
        handleShowSuggestions();
      }
    } else if (e.which == 13 && suggestions[suggestionIdx - 1]) {
      props.liftState(props.component, suggestions[suggestionIdx - 1][c_code]);
      setlastTyped(new Date().getTime());
      setSuggestionIdx(false);
      // focus on next element. 
    }
    // else if(e.which==9){

    // }
    else if (e.which == 27) {
      setSuggestions([]);
    }

  }



  const {
    name,
    label,
    placeHolder,
    isRequired,
    description,
    focus,
    disabled,
    isReadOnly,
    formmodal,
    displayData,
    forceRender,
    autoopen,
    insertonly,
    hidden,
    next_field
  } = props.component;
  let { conditionalRender } = props;

  let compTracker;
  if (name.indexOf(".") != -1) {
    let ct = name.split(".")
    compTracker = ct[ct.length - 1].replace("_code", "");
  }
  else if (name.indexOf("-") != -1) {
    let ct = name.split("-")
    compTracker = ct[ct.length - 1].replace("_code", "");
  }
  else {
    compTracker = name.replace("_code", "");
  }

  let { pageData, fileFolder, formState, openmodals, localpage, modalname, currentPage, errorMessages, LocalVars } = props.parentState;
  let { compressed, ShowHistory } = LocalVars;


  let typedValue = pageData[name];


  let isReadOnly1 = false;
  // console.log({name,conditionalRender});
  if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
    isReadOnly1 = true;
  }
  if (insertonly && !ShowHistory) {
    isReadOnly1 = true;
  }
  if (pageData.actionbuttons) {
    isReadOnly1 = true;
  }

  useMemo(() => getLatestData(false, isReadOnly1), [lastTyped]);

  let baseid = name.replace("_code", "") + "_id";
  let lastguid = pageData[baseid];

  // ASSUMPTION: Other controls will populate this control ONLY via this controls uid.
  useEffect(() => {
    if (lastguid) {
      getLatestData(true, isReadOnly1);
    }
  }, [lastguid]);


  // useEffect(() => {
  //   let nowtime = new Date().getTime();
  //   console.log({ nowtime, lastTyped })
  //   if (typedValue && (nowtime - lastTyped) > 2000 && lastTyped > 0) {
  //     getLatestData();
  //   }
  // }, [typedValue]);

  // useMemo(() => getLatestData(), [typedValue]);


  // Populate default value.
  useEffect(() => {
    let boxval = getDefaultValue(props);
    if (boxval) {
      props.liftState({ name }, boxval);
      setlastTyped(new Date().getTime());
    }
  }, []);


  let currentError;
  if (errorMessages) {
    if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
      currentError = errorMessages[modalname][name];
    } else if (!modalname && errorMessages[name]) {
      currentError = errorMessages[name];
    }
  }
  let textType = "text";

  if (props.component.textType) {
    textType = props.component.textType;
  }

  let boxvalue = typedValue;




  let cc = { ...props.component };
  cc.name = props.component.name + "_search";

  const handleControlSearch = () => {
    setSuggestionsDisplay(!suggestionsDisplay);
    let { openControls, currentPage } = props.parentState;
    openControls.push({ fastpath: props.component.fastpath, target: props.component.name, orig_fastpath: currentPage });
    props.liftGlobalState({ name: 'openControls' }, openControls);
    // props.liftGlobalState({name:'currentPage'}, props.component.fastpath);
  }


  if (props.component.name == "cnb_observation_type_code") {
    console.log({ component: props.component });
  }


  return (
    <div className={`form-group ${props.component.widths.parent} `} style={{ display: hidden ? "none" : "block" }}>

      {label && label != undefined && label != "" ? (
        <span>
          <label
            className=" col-form-label"
            // id={tooltipID}
            className={`col-form-label col-form-label-sm nopadding`}
          >
            {label}
          </label>
        </span>
      ) : (
        ""
      )}

      {/* {
        currentError &&
        <UncontrolledTooltip target={tooltipID2} placement="bottom">
          {currentError}
        </UncontrolledTooltip>
      } */}

      <div className="input-group input-group-sm ">
        {formmodal && <div className="input-group-append" style={{ display: "none" }}>
          <div className="input-group-text" style={{ padding: 4 }}>
            <FaRegWindowRestore
              style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }}
              className="hand btnSecondary"
            />
          </div>
        </div>}

        <input
          autoComplete="off"
          id={tooltipID2}
          style={{}}
          className={`${autoopen ? 'autoopen-textbox' : 'regular-field'} col-12 form-control form-control-sm primary ${!compressed ? "input-compressed" : ""} ${currentError ? "validationErrorBox" : ""}`}
          required={isRequired}
          readOnly={isReadOnly1}
          type={textType}
          name={name}
          placeholder={placeHolder}
          value={boxvalue}
          autoFocus={focus ? true : false}
          onChange={(e) => handleChange(e, props)}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onKeyDown={(e) => goToName(e, next_field, name, { props })}
          onKeyUp={e => showSuggestions(e)}
        />

        {!autoopen && (!formmodal || !isReadOnly1 || isReadOnly == 'force') &&
          <div className="input-group-append">
            <div className={`input-group-text 
          ${isLoading ? " animated flash infinite " : ""}
          `}
              style={{ padding: 4 }}>
              <FaRegWindowRestore
                onClick={() => (formmodal && isReadOnly1 && isReadOnly != 'force') ? () => false : handleControlSearch()}
                style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }}
                className={`${(formmodal && isReadOnly1 && isReadOnly != 'force') ? '' : 'hand'} btnSecondary`}
              />
            </div>
          </div>
        }

        {autoopen && <div className="input-group-append">
          <div className={`input-group-text  input-group-custom
          ${isLoading ? " animated flash infinite " : ""}
          `}
            style={{ padding: 4 }}>
            <RelevantIcon icon="down-carat"
              onClick={() => (formmodal && isReadOnly1 && isReadOnly != 'force') ? () => false : handleShowSuggestions()}
              style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }}
              className={`${(formmodal && isReadOnly1 && isReadOnly != 'force') ? '' : 'hand'} btnSecondary`} />

            {/* <FaArrowDown
              onClick={handleShowSuggestions}
              style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }}
              className="hand btnSecondary"
            /> */}
          </div>
        </div>
        }
      </div>

      {(suggestions.length > 0 && !suggestionsDisplay) &&
        <Suggestions data={suggestions} />
      }

    </div>
  );
}

export default CommonControlCustom;